const { NODE_ENV, START_TIME } = process.env;

window.__env = NODE_ENV;
window.__startTime = START_TIME;
